import { render, staticRenderFns } from "./editProductType.vue?vue&type=template&id=7968bf52&scoped=true&"
import script from "./editProductType.vue?vue&type=script&lang=js&"
export * from "./editProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968bf52",
  null
  
)

export default component.exports